import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar, { MobileHeader, MobileDrawer } from "./Sidebar";
import Footer from "./Footer";
import AudioPlayerBar from "./AudioPlayerBar";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { usePlayer } from "../context/PlayerContext";
import AdSlot from "./AdSlot";

export const Layout = () => {
  const [enabled, setEnabled] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { currentTrack } = usePlayer();
  const loc = useLocation();

  const { user } = useAuth();

  useEffect(() => {
    // Endpoint public si non connecté, sinon endpoint admin (qui donne plus de détails si admin)
    const url = user ? "/admin/sections" : "/sections";
    api.get(url).then(({ data }) => {
      const map = {};
      data.forEach((s) => { map[s.section] = s.enabled; });
      setEnabled(map);
    }).catch(() => {
      // Fallback : essaie l'endpoint public si l'admin a échoué (token expiré, etc.)
      if (user) {
        api.get("/sections").then(({ data }) => {
          const map = {};
          data.forEach((s) => { map[s.section] = s.enabled; });
          setEnabled(map);
        }).catch(() => {});
      }
    });
  }, [loc.pathname, user]);

  // Close drawer on route change
  useEffect(() => { setDrawerOpen(false); }, [loc.pathname]);

  // Heartbeat — met à jour last_seen toutes les 90s pour les utilisateurs connectés
  useEffect(() => {
    if (!user) return;
    const ping = () => { api.post("/heartbeat").catch(() => {}); };
    ping();
    const iv = setInterval(ping, 90_000);
    return () => clearInterval(iv);
  }, [user]);

  // Global scroll reveal via IntersectionObserver
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    document.querySelectorAll(".reveal-on-scroll:not(.is-visible)").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [loc.pathname]);

  return (
    <div className="flex min-h-screen flex-col lg:flex-row" data-testid="app-layout">
      <Sidebar enabledSections={enabled} />
      <MobileHeader enabledSections={enabled} onMenuClick={() => setDrawerOpen(true)} />
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} enabledSections={enabled} />
      <main className={`flex-1 w-full min-w-0 flex flex-col ${currentTrack ? "pb-24" : ""}`}>
        <div className="flex-1">
          <Outlet context={{ enabled }} />
        </div>
        <div className="px-6 md:px-12 max-w-7xl mx-auto w-full pb-8">
          <AdSlot placement="footer" />
        </div>
        <Footer />
      </main>
      <AdSlot placement="popup" />
      <AudioPlayerBar />
    </div>
  );
};

export default Layout;
